/**
 * @module FE-CU24_機器制御画面
 */
import Header from '../../components/header/Header.vue';
import ListPanel from '../../components/listPanel/ListPanel.vue';
import BreadCrumbList from '../../components/breadCrumb/List.vue';
import PcPageTitle from '../../components/pcPageTitle/PcPageTitle.vue';
import MobileFooter from '../../components/footer/MobileFooter.vue';
import PCFooter from '@/components/footer/PCFooter.vue';
import CONSTANTS from '../../constants';

const PAGE_ID = 'FE-CU24';

export default {
  name: 'MachineControl',
  components: {
    Header,
    ListPanel,
    BreadCrumbList,
    PcPageTitle,
    MobileFooter,
    PCFooter,
  },
  data(vm) {
    return {
      title: vm.$vuetify.lang.t('$vuetify.FECU24機器制御画面.機器制御'),
      hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU24機器制御画面.C0001'),
      dialog: false,
      myDataVariable: '',
      initIsEquipmentControl: [],
      items: [],
      // items: [
      //   //モック一時対応
      //   {
      //     title: "警備ユニット(音)",
      //     isEquipmentControl: true,
      //   },
      //   {
      //     title: "ALSOKライト(玄関)",
      //     isEquipmentControl: false,
      //   },
      //   {
      //     title: "警報ブザー(廊下)",
      //     isEquipmentControl: false,
      //   },
      //   {
      //     title: "警備ベル(庭)",
      //     isEquipmentControl: true,
      //   },
      // ],
      panelTitle: {
        place: `- `,
        type: '$vuetify.FECU24機器制御画面.対象地区',
        typeIsBefore: true,
      },
      displayAreaList: [
        {
          id: 1,
          title: '$vuetify.FECU24機器制御画面.対象地区詳細領域.利用プラン',
          text: '',
          isVuetifyKey: true,
        },
        {
          id: 2,
          title: '$vuetify.FECU24機器制御画面.対象地区詳細領域.お客様番号',
          text: '',
        },
        {
          id: 3,
          title: '$vuetify.FECU24機器制御画面.対象地区詳細領域.警備先名',
          text: '',
        },
        {
          id: 4,
          title: '$vuetify.FECU24機器制御画面.対象地区詳細領域.地区番号',
          text: '',
        },
        {
          id: 5,
          title: '$vuetify.FECU24機器制御画面.対象地区詳細領域.地区名',
          text: '',
        },
      ],
      disableFlag: true,
      CONSTANTS: CONSTANTS,
      width: 0,
      //ページの表示タイミング
      isShowPage: false,
    };
  },
  computed: {
    i18nItems(vm) {
      return {
        title: vm.$vuetify.lang.t('$vuetify.FECU24機器制御画面.機器制御'),
        hintText: vm.$vuetify.lang.t('$vuetify.メッセージ一覧.FECU24機器制御画面.C0001'),
      };
    },
  },
  watch: {
    items: {
      handler: function (val) {
        var newIsEquipmentControl = [];
        val.forEach(function (element) {
          newIsEquipmentControl.push(element.isEquipmentControl);
        });
        if (JSON.stringify(newIsEquipmentControl) == JSON.stringify(this.initIsEquipmentControl)) {
          this.disableFlag = true;
        } else {
          this.disableFlag = false;
        }
      },
      deep: true,
    },
  },
  /** @type {Methods} */
  methods: {
    /**
     * 機器制御データ取得API実行処理
     * @param {*} param URLパラメータ
     * @param {*} queries リクエストパラメータ
     * @param {*} method メソッドパラメータ
     * @returns apiData レスポンス
     */
    APP_CU2401: async function (param, queries, method) {
      this.$_setLoading(true);

      let apiData = '';
      await this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     displayDistrictInfo: {
            //       usagePlan: 0,
            //       customerNumber: "51-1234567",
            //       securityDestinationName: "警備先1",
            //       districtSplitNumber: "0001",
            //       districtSplitName: "地区名1",
            //       displayDistrictNickname: "自宅",
            //     },
            //     sendCustomerNumber: "51-1234567",
            //     sendCommandKey: "123456789",
            //   },
            // };

            // データをマッピング
            let displayDistrictInfo = apiData.contentsInfo.displayDistrictInfo;
            this.panelTitle.place = '- ' + displayDistrictInfo.displayDistrictNickname;
            switch (displayDistrictInfo.usagePlan) {
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN:
                this.displayAreaList[0].text = '$vuetify.コード.利用プランID.オンライン監視プラン';
                break;
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN:
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE:
                this.displayAreaList[0].text = '$vuetify.コード.利用プランID.依頼かけつけプラン';
                break;
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN:
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE:
                this.displayAreaList[0].text = '$vuetify.コード.利用プランID.セルフ監視プラン';
                break;
              default:
                break;
            }
            this.displayAreaList[1].text = displayDistrictInfo.customerNumber;
            this.displayAreaList[2].text = displayDistrictInfo.securityDestinationName;
            this.displayAreaList[3].text =
              displayDistrictInfo.districtSplitNumber === '    '
                ? '$vuetify.FECU24機器制御画面.メイン地区'
                : displayDistrictInfo.districtSplitNumber;
            this.displayAreaList[4].text = displayDistrictInfo.districtSplitName;
          },
          (error) => {
            // 異常系処理
            this.$_abnormality(error.response.status);
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 機器制御データ更新API実行処理
     * @returns apiData レスポンス
     */
    APP_CU2402: function () {
      this.$_setLoading(true);

      let method = 'post';
      let param = '/api/equipmentControl/update';
      // let param = "post"; // 検証用
      let equipmentArray = [];

      let tempInitIsEquipmentControl = this.initIsEquipmentControl;

      this.items.forEach(function (element, idx) {
        if (element.isEquipmentControl !== tempInitIsEquipmentControl[idx]) {
          equipmentArray.push({
            equipmentNumber: element.equipmentNumber,
            isEquipmentControl: element.isEquipmentControl,
          });
        }
      });

      let queries = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        customerNumber: this.$store.state.customerNumber,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        equipmentList: equipmentArray,
      };

      let apiData = '';
      this.$store
        .dispatch(`requestApi/${method}ApiInfoAction`, {
          url: param,
          params: queries,
        })
        .then(
          async (response /* eslint-disable-line */) => {
            apiData = this.$store.getters[`requestApi/${method}ApiInfo`];
            // // サンプルデータ
            // apiData = {
            //   contentsInfo: {
            //     sendCustomerNumber: "123456789",
            //     sendCommandKey: "123456",
            //   },
            // };

            if (typeof apiData.contentsInfo !== 'undefined') {
              let params = {
                token: sessionStorage.getItem('token'),
                terminalInfo: localStorage.getItem('terminalInfo')
                  ? localStorage.getItem('terminalInfo')
                  : '',
                sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
                sendCommandKey: apiData.contentsInfo.sendCommandKey,
                apiId: 17,
                alarmType: 0,
                districtSplitNumber: this.$store.state.districtSplitNumber,
                securityAreaId: '',
              };
              await this.APP_CU2402_CO9915(params);
            }
          },
          (error) => {
            if (error.response.status == '400') {
              // エラーダイアログを表示
              this.$errorDialog('$vuetify.メッセージ一覧.FECU24機器制御画面.E0001');
            } else {
              // 異常系処理
              this.$_abnormality(error.response.status);
            }
          }
        )
        .finally(() => {
          this.$_setLoading(false);
        });

      return apiData;
    },
    /**
     * 警備ユニットコマンド実行結果確認API実行処理(APP_CU2401)
     * @param {*} params リクエストパラメータ
     * @param {*} initData 機器制御データ
     * @returns apiData レスポンス
     */
    APP_CU2401_CO9915: async function (params, initData) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          // // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu2401: {
          //         equipmentList: [
          //           {
          //             equipmentNumber: 1,
          //             equipmentName: "警備ユニット(音)",
          //             isEquipmentControl: true,
          //           },
          //           {
          //             equipmentNumber: 2,
          //             equipmentName: "ALSPKライト(玄関)",
          //             isEquipmentControl: true,
          //           },
          //           {
          //             equipmentNumber: 3,
          //             equipmentName: "警報ブザー(廊下)",
          //             isEquipmentControl: true,
          //           },
          //           {
          //             equipmentNumber: 4,
          //             equipmentName: "警備ベル(庭)",
          //             isEquipmentControl: false,
          //           },
          //         ],
          //       },
          //     },
          //   },
          // };
          if (apiData.contentsInfo.securityUnitExecutionResult == 0) {
            // データをマッピング
            let displayDistrictInfo = initData.contentsInfo.displayDistrictInfo;

            switch (displayDistrictInfo.usagePlan) {
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.ONLINE_MONITORING_PLAN:
                this.displayAreaList[0].text = '$vuetify.コード.利用プランID.オンライン監視プラン';
                break;
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN:
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.EMERGENCY_ASSISTANCE_ON_DEMAND_PLAN_NO_DEVICE:
                this.displayAreaList[0].text = '$vuetify.コード.利用プランID.依頼かけつけプラン';
                break;
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN:
              case CONSTANTS.HOME_SECURITY_USAGE_PLAN.SELF_MONITORING_PLAN_NO_DEVICE:
                this.displayAreaList[0].text = '$vuetify.コード.利用プランID.セルフ監視プラン';
                break;
              default:
                break;
            }
            this.displayAreaList[1].text = displayDistrictInfo.customerNumber;
            this.displayAreaList[2].text = displayDistrictInfo.securityDestinationName;
            this.displayAreaList[3].text =
              displayDistrictInfo.districtSplitNumber === '    '
                ? '$vuetify.FECU24機器制御画面.メイン地区'
                : displayDistrictInfo.districtSplitNumber;
            this.displayAreaList[4].text = displayDistrictInfo.districtSplitName;
            apiData.contentsInfo.commandExecutionResult.app_cu2401.equipmentList.forEach(
              (element) => {
                this.items.push({
                  title: element.equipmentName,
                  equipmentNumber: element.equipmentNumber,
                  isEquipmentControl: element.isEquipmentControl,
                });
              }
            );

            let array = [];
            this.items.forEach(function (element) {
              array.push(element['isEquipmentControl']);
            });
            this.initIsEquipmentControl = array;
          } else {
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
          }
        })
        .finally(() => {
          // ブラウザバック時に遷移先で Loading が途切れるのを回避
          if (this.$route.name === this.$options.name) {
            this.$_setLoading(false);
          }
        });

      return apiData;
    },
    /**
     * 警備ユニットコマンド実行結果確認API実行処理(APP_CU2402)
     * @param {*} params リクエストパラメータ
     * @returns apiData レスポンス
     */
    APP_CU2402_CO9915: async function (params) {
      this.$_setLoading(true);
      let apiData = '';
      await this.$store
        .dispatch(`requestApi/postSecurityUnitExecutionResult`, {
          params: params,
        })
        .then((response /* eslint-disable-line */) => {
          apiData = response;
          // // サンプルデータ
          // apiData = {
          //   contentsInfo: {
          //     securityUnitExecutionResult: 0,
          //     commandExecutionResult: {
          //       app_cu2402: {
          //         deviceNumber: "",
          //         controlResult: 0,
          //       },
          //     },
          //   },
          // };

          if (
            apiData.contentsInfo.securityUnitExecutionResult == 0 &&
            apiData.contentsInfo.commandExecutionResult.app_cu2402.controlResult === 0
          ) {
            this.callMessageDialog('$vuetify.FECU24機器制御画面.登録が完了しました');
          } else if (
            apiData.contentsInfo.securityUnitExecutionResult == 0 &&
            apiData.contentsInfo.commandExecutionResult.app_cu2402.controlResult === 1
          ) {
            // エラーダイアログを表示
            this.$errorDialog('$vuetify.メッセージ一覧.FECU24機器制御画面.E0001');
          } else {
            this.$_securityUnitExecutionResultDialog(
              apiData.contentsInfo.securityUnitExecutionResult
            );
          }
        })
        .finally(() => {
          this.$_setLoading(false);
        });
      return apiData;
    },
    /**
     * 登録完了ダイアログ表示
     * @param {*} text 完了メッセージ
     */
    async callMessageDialog(text) {
      await this.$informationDialog(text);

      // 再表示
      window.location.reload();
    },
    /**
     * 設定ボタン押下時処理
     * 確認ダイアログを表示して更新APIを実行
     */
    async callSaveAgreementDialogDialog() {
      const result = await this.$agreementDialog(
        '$vuetify.agreementDialog.確認',
        '$vuetify.メッセージ一覧.FECU24機器制御画面.C0002',
        '$vuetify.agreementDialog.いいえボタン',
        '$vuetify.agreementDialog.はいボタン'
      );
      if (result === true) {
        // 更新処理実行
        this.APP_CU2402();
      }
    },
    /**
     * widthを調整
     * @param {number} width 幅
     */
    changeItemLabelWidth(width) {
      this.width = width;
    },
  },
  async mounted() {
    window.scroll({ top: 0, behavior: 'smooth' });
    this.$_pvCount(PAGE_ID);

    // 自動ログアウト
    this.$_setTimer();
    this.$_setEvents(this.$_resetTimer);

    if (this.$store.getters['isLoggedIn']) {
      await this.$refs.header.APP_CU0201();
    }

    this.$watch('$mq', function () {
      this.changeItemLabelWidth(
        this.$mq === 'pc'
          ? CONSTANTS.LIST_PANEL_LABEL_WIDTH.PC
          : CONSTANTS.LIST_PANEL_LABEL_WIDTH.SP
      );
    });

    //以降は、ローディングマークを出して警備ユニットとの通信なので、ここで画面表示
    this.isShowPage = true;

    let method = 'post';
    let param = '/api/equipmentControl/init';

    let queries = {
      token: sessionStorage.getItem('token'),
      terminalInfo: localStorage.getItem('terminalInfo')
        ? localStorage.getItem('terminalInfo')
        : '',
      customerNumber: this.$store.state.customerNumber,
      districtSplitNumber: this.$store.state.districtSplitNumber,
    };

    let apiData = await this.APP_CU2401(param, queries, method);

    if (typeof apiData.contentsInfo !== 'undefined') {
      let params = {
        token: sessionStorage.getItem('token'),
        terminalInfo: localStorage.getItem('terminalInfo')
          ? localStorage.getItem('terminalInfo')
          : '',
        sendCustomerNumber: apiData.contentsInfo.sendCustomerNumber,
        sendCommandKey: apiData.contentsInfo.sendCommandKey,
        apiId: 16,
        alarmType: 0,
        districtSplitNumber: this.$store.state.districtSplitNumber,
        securityAreaId: '',
      };
      await this.APP_CU2401_CO9915(params, apiData);
    }
  },
};
